import { render, staticRenderFns } from "./RestaurantGroupCard.vue?vue&type=template&id=1314ae10&scoped=true&"
import script from "./RestaurantGroupCard.vue?vue&type=script&lang=js&"
export * from "./RestaurantGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantGroupCard.vue?vue&type=style&index=0&id=1314ae10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1314ae10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
